import { render } from "./work.vue?vue&type=template&id=cbf77628&scoped=true"
import script from "./work.vue?vue&type=script&lang=js"
export * from "./work.vue?vue&type=script&lang=js"

import "./work.vue?vue&type=style&index=0&id=cbf77628&lang=scss&scoped=true"

import exportComponent from "/home/mark/Dev/www/Portfolio/portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbf77628"]])

export default __exports__